export default {
  interval: { key: 'interval', value: 'через интервал' },
  until: { key: 'until', value: 'в указанный момент' }
};
